export const planFeatureMap = {
  standard: [
    "Free for smaller teams",
    "Employee self-service portal",
    "Core payroll reporting",
    "Simple onboarding for your team",
  ],
  premium: [
    "Flexible workforce onboarding",
    "Staff remittance support",
    "Pension remittance support",
    "Comprehensive payroll reporting access",
  ],
};

export const getPlanFeatures = (planName) => {
  const normalizedName = (planName || "standard").toLowerCase();
  return [...(planFeatureMap[normalizedName] || planFeatureMap.standard)];
};

export const pricing = [
  {
    name: "Standard",
    features: getPlanFeatures("Standard"),
  },
  {
    name: "Premium",
    features: getPlanFeatures("Premium"),
  },
];
